import { BaseEdge, EdgeLabelRenderer, getBezierPath, Position } from '@xyflow/react'
import { useState } from 'react'
import { FaTimes } from 'react-icons/fa'

interface iCustomEdgeProps {
  id: string
  sourceX: number
  sourceY: number
  targetX: number
  targetY: number
  sourcePosition: Position
  targetPosition: Position
  style?: React.CSSProperties
  markerEnd?: string
  data?: {
    podeExcluir?: boolean
    onExcluir?: (id: string) => void
  }
}

const CustomEdge: React.FC<iCustomEdgeProps> = ({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition,
  targetPosition,
  style,
  markerEnd,
  data
}) => {
  const [Hover, setHover] = useState(false)

  const [caminho, centroX, centroY] = getBezierPath({
    sourceX,
    sourceY,
    sourcePosition,
    targetX,
    targetY,
    targetPosition
  })

  return (
    <>
      <g onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
        <BaseEdge
          id={id}
          path={caminho}
          markerEnd={markerEnd}
          interactionWidth={30}
          style={{
            ...style,
            stroke: Hover ? 'var(--terc3)' : style?.stroke,
            strokeWidth: Hover ? 4 : style?.strokeWidth
          }}
        />
      </g>

      {data?.podeExcluir === true && (
        <EdgeLabelRenderer>
          <button
            type='button'
            title='Excluir ligação'
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            onClick={() => data.onExcluir?.(id)}
            style={{
              position: 'absolute',
              transform: `translate(-50%, -50%) translate(${centroX}px, ${centroY}px)`,
              pointerEvents: 'all',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '1.5rem',
              height: '1.5rem',
              borderRadius: '50%',
              cursor: 'pointer',
              background: Hover ? 'var(--terc3)' : 'var(--c1)',
              color: Hover ? 'var(--c1)' : 'var(--terc3)',
              border: '2px solid var(--terc3)',
              opacity: Hover ? 1 : 0.6,
              fontSize: '.75rem'
            }}
          >
            <FaTimes />
          </button>
        </EdgeLabelRenderer>
      )}
    </>
  )
}

export default CustomEdge
